import { MODULE_DISABLED_CODE, MODULE_DISABLED_EVENT } from 'constants.js';

// Axios may hand back a string body (or none) for non-JSON responses; never throw while inspecting it.
const getResponseBody = (error) => {
    const data = error?.response?.data;
    if (typeof data === 'string') {
        try {
            return JSON.parse(data);
        } catch (_e) {
            return null;
        }
    }
    return data && typeof data === 'object' ? data : null;
};

/** True when an axios error is the backend's 403 MODULE_DISABLED response. */
export const isModuleDisabledResponse = (error) =>
    error?.response?.status === 403 && getResponseBody(error)?.code === MODULE_DISABLED_CODE;

/** True for the Error produced by `toApiError` from a MODULE_DISABLED response. */
export const isModuleDisabledError = (error) => error?.code === MODULE_DISABLED_CODE;

/** Tells the mounted ModuleGuard(s) that a module has been switched off. */
export const notifyModuleDisabled = (error) => {
    window.dispatchEvent(
        new CustomEvent(MODULE_DISABLED_EVENT, { detail: { module: getResponseBody(error)?.module } })
    );
};

/** Builds the Error thrown from query functions, keeping the MODULE_DISABLED code for onError handlers. */
export const toApiError = (error) => {
    const body = getResponseBody(error);
    const apiError = new Error(body?.message);
    if (isModuleDisabledResponse(error)) {
        apiError.code = MODULE_DISABLED_CODE;
        apiError.module = body?.module;
    }
    return apiError;
};
